import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { ReactSVG } from 'react-svg'
import { isAndroid, isIPad } from '../../classes/Platform'
import { BnForm, BnFormFieldSeparator as Sep } from '../Form'
import { BnAnimatedLabel, BnLabel1, BnLabel2 } from '../Label'
import { BnButton, BnBackButton, BnOKButton, BnLogoSmall, BnMenu, BnSearchResult } from '../Button'
import { getPortal } from '../Client'
import './index.css'

export class BnSubpage extends Component {
  constructor (props) {
    super(props)
    this.state = {
      form: {}
    }
  }

  renderContent() {
    return <div className='bnContentPage'>
      </div>
  }

  back = () => {
    this.setState({
      subpage: null,
      popup: null
    })
  }

  getForm = () => this.props.form || this.state.form
  getFormErr = () => this.state.formErr || this.props.formErr

  clearFormErr = () => {
    this.reportFormErr(null)
  }
  
  reportFormErr = formErr => {
    console.log(formErr)
    if (this.props.reportFormErr) {
      return this.props.reportFormErr(formErr)
    }
    this.setState({
      formErr
    })
  }

  set = (field, value) => {
    this.onChange(field, value)
  }

  get = field => {
    return this.getForm()[field]
  }

  onChange = (field, value) => {
    if (this.props.onChange) {
      this.reportFormErr(null)
      return this.props.onChange(field, value)
    }
    const form = this.state.form
    this.state.form[field] = value
    this.state.formErr = null
    this.forceUpdate()
  }

  renderTitle = () => {
    if (!this.props.title) return null
    return <div className='bnPageTitle'>{this.props.title}</div>
  }

  renderPopupTitle() {
    return <div className='bnPagePopupTitle'>
      {this.renderTitle()}
      </div>
  }

  async performDefaultAction() {
    this.props.action(this.getForm())
  }

  async performAction() {
    await this.performDefaultAction()
  }
 
  render () {
    let subpage
    let popup
    if (this.state.subpage) {
      subpage = this.state.subpage()
    }
    if (this.state.popup) {
      popup = this.state.popup()
    }
    const content = this.renderContent()
    //console.log('content', content)
    //console.log('actionLabel: ', this.props.actionLabel)
    return <div className='bnContentPage'>
      <BnPage me={this.props.me} subpage={subpage} popup={popup} safeArea={this.props.safeArea}>
      {(this.props.back || this.props.action) &&
       [<div key='buttons' className='bnPageButtons'>
        {this.props.back && <BnBackButton isCancel={this.props.isCancel} action={this.props.back}/>}
        {this.renderTitle()}
        {this.props.action && <BnOKButton label={this.props.actionLabel || this.state.actionLabel} action={()=>this.performAction()}/>}
        </div>,
        ] }
 
    <div className='bnPageContentArea'>
      {content}
    </div>
        </BnPage>
      </div>
  }
}


export class BnPage extends Component {

  constructor (props) {
    super(props)
    this.state = {
      alpha: 0
    }
    if (!props.me) {
      debugger
    }
  }

  componentDidMount () {
    if (this.props.onCreate) this.props.onCreate(this)
    if (this.props.subpage) {
      this.slide(1, { subpage: this.props.subpage, popup: null })
    } else if (this.props.popup) {
      this.slide(1, { popup: this.props.popup, subpage: null })
    }
  }

  componentDidUpdate (prevProps) {
    const subpage = this.props.subpage
    if ((subpage && !prevProps.subpage) || (!subpage && prevProps.subpage)) {
      if (subpage) {
        this.slide(1, { subpage, popup: null })
      } else {
        this.slide(0)
      }
    }
    const popup = this.props.popup
    if ((popup && !prevProps.popup) || (!popup && prevProps.popup)) {
      if (popup) {
        this.slide(1, { popup, subpage: null })
      } else {
        this.slide(0)
      }
    }
  }

  componentWillUnmount () {
    clearTimeout(this.endSlideTimeout)
  }

  slide = (target, content = {}) => {
    const pageScroller = this.pageScroller
    if (pageScroller && target === 1 && this.state.alpha === 0) {
      this.scrollPos = pageScroller.scrollTop
      pageScroller.scrollTop = 0
    } else if (pageScroller && target === 0) {
      pageScroller.scrollTop = this.scrollPos
    }

    clearTimeout(this.endSlideTimeout)
    this.setState({
      ...content,
      alpha: target,
      alphaTransition: true
    }, () => {
      if (this.props.onAlphaChange) this.props.onAlphaChange(this.state.alpha)
    })

    // transitionend is authoritative; this only covers interrupted or disabled
    // CSS transitions so stale subpages cannot remain mounted indefinitely.
    this.endSlideTimeout = setTimeout(this.endSlide, 450)
  }

  endSlide = () => {
    clearTimeout(this.endSlideTimeout)
    this.endSlideTimeout = null
    if (!this.state.alpha && this.props.me.self) {
      this.props.me.setStatusBarColor('light-content')
    }

    const updates = { alphaTransition: false }
    if (!this.props.subpage) updates.subpage = null
    if (!this.props.popup) updates.popup = null
    this.setState(updates)
  }

  finishPageTransition = event => {
    if (event.target !== event.currentTarget || event.propertyName !== 'transform') return
    this.endSlide()
  }

  finishPopupTransition = event => {
    if (event.target !== event.currentTarget || event.propertyName !== 'transform') return
    this.endSlide()
  }

  renderPopup () {
    const popup = this.props.popup || this.state.popup
    if (!popup) return null

    let popupClassName = 'bnPagePopup'
    if (!this.props.me.isNative() && !isIPad()) {
      popupClassName += ' bnMobileWebPopup'
    }
    const popupBackgroundClassName = this.state.alpha
      ? 'bnPagePopupBg bnPagePopupBgSlideIn'
      : 'bnPagePopupBg bnPagePopupBgSlideOut'
    const node = <div
      key='popup'
      className={popupBackgroundClassName}
      onTransitionEnd={this.finishPopupTransition}>
      <div className={popupClassName}>{popup}</div>
    </div>
    const portalRef = document.getElementById('popup-root') || getPortal()
    return portalRef ? ReactDOM.createPortal(node, portalRef) : node
  }

  scrollPos = 0;

  setScrollRef = n => {
    if (n) {
      this.pageScroller = n
      const self = this
      this.pageScroller.onscroll = (e) => {
        console.log('scroll: ', this.props.title, n.scrollTop)
        if (this.state.popup || this.state.subpage) {
          e.preventDefault()
          n.scrollTo(0, this.scrollPos)
          return
        }
        const pos = n.scrollTop
        //console.log('pos=', pos)
        if ((this.scrollPos <= 40 && pos > 40) || (this.scrollPos > 40 && pos <= 40)) {
          this.scrollPos = pos
          this.setState({
            scrolled: pos > 40
          })
        } else {
          this.scrollPos = pos
        }
      }
      if (this.scrollPos !== n.scrollTop) {
        this.scrollPos = n.scrollTop
      }
    }
  }

  back = async () => {
    //console.log("alpha:", this.state.alpha, "leaving:", this.leaving)
    if (this.state.alpha !== 0) {
      return
    }
    debugger
    return this.props.back()
  }

  cancel = async () => {
    if (this.state.alpha !== 0) {
      return
    }
    return this.props.cancel()
  }

  next = async (arg) => {
    if (this.state.alpha !== 0) {
      return
    }
    return this.props.done(arg)
  }
  
  renderSafeArea = () => {
    const self = this
    if (window.ReactNativeWebView || this.props.safeArea) {
      let style
      if (isAndroid() && window.safeAreaInsets) {
        const { top, bottom } = window.safeAreaInsets
        style = {
          height: (top + bottom)+'px'
        }
      }
      return <div className='bnPageHeaderSafeArea' style={style}/>
    }
    return null
  }

  render () {
    const subpage = this.props.subpage || this.state.subpage || null
    let bodyStyle
    let scrollerStyle
    if (this.props.noHeader) {
      scrollerStyle = { maxHeight: '100%' }
    }
    if (this.props.header) {
      scrollerStyle = { maxHeight: '100%' }
    }
    if (this.props.customSearch) {
      bodyStyle = {
        height: 'calc(100% - 64px)'
      }
    }
    let className = 'bnPage'  + (this.props.embed ? ' bnPageEmbed' : '')
    if (this.props.safeArea) {
      className += ' bnPageSafeArea'
    }

    let contentClassName = 'bnPageContent'
    let bodyClassName = 'bnPageBody'
    let subpageClassName = 'bnPageSubpage'
    if (subpage) {
      if (this.state.alpha) {
        contentClassName += ' bnPageContentSlideIn'
        bodyClassName += ' bnPageContentFadeOut'
        subpageClassName += ' bnPageContentFadeIn'
      } else {
        contentClassName += ' bnPageContentSlideOut'
        bodyClassName += ' bnPageContentFadeIn'
        subpageClassName += ' bnPageContentFadeOut'
      }
    }

    return (
      <div className='bnPageBackground'>
        <div className={className}>
          {this.renderSafeArea()}
          <div className='bnPageCamera'>
            <div className={contentClassName} onTransitionEnd={this.finishPageTransition}>
              <div className='bnPageScroller' ref={this.setScrollRef} style={scrollerStyle}>
                <div className={bodyClassName} style={bodyStyle}>
                  {this.props.children}
                </div>
                {this.props.subpages
                  ? <div key='subpage' className={subpageClassName}>
                    {this.props.subpages.map((page, index) => {
                      return <div key={index} className='bnSubpageContainer' style={subpage ? null : { display: 'none' }}>
                        {page}
                      </div>
                    })}
                  </div>
                  : subpage ? <div className={subpageClassName}>{subpage}</div> : null}
                <div className='bnPageFooter'>{this.props.footer}</div>
              </div>
            </div>
          </div>
          {this.renderPopup()}
        </div>
      </div>
    )
  }
}
